export enum ContentType {
  Event = 'EVENT_CARD',
  Article = 'ARTICLE_CARD',
  Announcement = 'ANNOUNCEMENT_CARD',
  Closing = 'CLOSING_CARD',
}
